import { Injectable } from "@angular/core";
import { ModuloResponse } from "../../_infrastructure/dtos/core/modulo/ModuloResponse";
import { ClienteResponse } from "../../_infrastructure/dtos/core/cliente/ClienteResponse";

@Injectable({ providedIn: 'root' })
export class ModuloNavigationService {

    resolveUrl(
        modulo: ModuloResponse,
        cliente: ClienteResponse
    ): string {

        const clienteModulo = cliente.clienteModulos
            ?.find(cm => cm.moduloId === modulo.id);

        if (clienteModulo?.redirectUrl) {
            return clienteModulo.redirectUrl;
        }

        return modulo.urlAcessoPortalTransparencia;
    }

    isExternal(url: string): boolean {
        return /^https?:\/\//i.test(url);
    }
}
